var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248 96h16v59h-16zM248 357h16v59h-16zM357 248h59v16h-59zM96 248h59v16H96zM368.27 354.263l-11.88 11.88-33.8-33.8 11.88-11.88zM191.555 177.593l-11.88 11.88-33.87-33.87 11.88-11.88zM356.313 143.745l11.878 11.88-33.805 33.795-11.877-11.88zM179.638 320.468l11.877 11.88-33.875 33.866-11.877-11.88zM257.1 330.7c-41.8 0-75.8-34-75.8-75.8s34-75.8 75.8-75.8 75.8 34 75.8 75.8c-.1 41.8-34.1 75.8-75.8 75.8zm0-134.7c-32.5 0-58.9 26.4-58.9 58.9s26.4 58.9 58.9 58.9 58.9-26.4 58.9-58.9-26.4-58.9-58.9-58.9z"
  })));
};
export default SvgSun;